import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { errorMessage } from '../lib/api';

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 3 }}>
      <CircularProgress size={20} />
      <Typography>{label}</Typography>
    </Box>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <Alert
      severity="error"
      sx={{ my: 1 }}
      action={
        onRetry ? (
          <Button color="inherit" onClick={onRetry}>
            Retry
          </Button>
        ) : undefined
      }
    >
      {errorMessage(error)}
    </Alert>
  );
}

export function ForbiddenState({ code }: { code?: string }) {
  return (
    <Alert severity="warning" sx={{ m: 2 }}>
      You do not have permission to open this page{code ? ` (${code})` : ''}. Ask an administrator
      to add it to your user group.
    </Alert>
  );
}

/** Shown in tables and lists with no rows. Default wording matches the reference. */
export const EMPTY_TEXT =
  'No records match the selected criteria. Please adjust your search parameters and try again.';
